// extracted by mini-css-extract-plugin
module.exports = {"root":"Table_root__2iD8M","head":"Table_head__3Q6hm","col":"Table_col__pGNmO"};